import {
  identity, pickBy, toNumber, toString,
} from 'lodash/fp';
import { http } from '../common/utils';
import { CLASSTING_API_URL } from '../common/constants';

export const createContact = ({
  sid, grade, clazzName, name, clazzNumber, email, phoneNumber, clazzGroup, customGroups,
}) => http.post(
  `${CLASSTING_API_URL}/v1/schools/${sid}/contacts`,
  pickBy(identity, {
    contact: pickBy(identity, {
      email,
      grade: toNumber(grade),
      name,
      class_name: toString(clazzName),
      number: toNumber(clazzNumber),
      mobile: phoneNumber,
      class_group_id: clazzGroup,
      custom_group_ids: customGroups,
    }),
  }),
);

export const createGuardianContact = ({
  cid, email, level, name, phoneNumber, relationship,
}) => http.post(
  `${CLASSTING_API_URL}/v1/contacts/${cid}/guardian_contacts`,
  pickBy(identity, {
    email,
    level,
    name,
    relationship,
    mobile: phoneNumber,
  }),
);

export const createContacts = ({ sid, contacts }) => http.post(
  `${CLASSTING_API_URL}/v1/schools/${sid}/contacts/batch`,
  { contacts },
);
